import React from "react";
import Footer from "./Footer";
import styled from "styled-components";
import Base from "./Base";

const LayoutWrapper = styled.div`
  font-family: "Poppins", sans-serif;
`;

const Layout = ({ children }) => (
  <Base>
    <LayoutWrapper>
      {children}
      <Footer />
    </LayoutWrapper>
  </Base>
);

export default Layout;
